import React, { CSSProperties } from 'react';
import { Button } from "@headlessui/react";

interface Props {
    label: string;
    onClick: () => void;
    className?: string;
    style?: CSSProperties;
    disabled?: boolean;
}

export function PrimaryButton({ style, className, label, onClick, disabled }: Props) {
    return (
        <Button
            onClick={onClick}
            className="button primary"
            style={style}
            disabled={disabled}
        >
            {label}
        </Button>
    );
}

export function SecondaryButton({ style, className, label, onClick }: Props) {
    return (
        <Button
            onClick={onClick}
            className="button secondary"
            style={style}
        >
            {label}
        </Button>
    );
}
